var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 19.641L11.4 21.7949C11.7556 22.0684 12.2444 22.0684 12.6 21.7949L15.4 19.641C15.7556 19.3675 16.2444 19.3675 16.6 19.641L18.4 21.0256C19.0592 21.5327 20 21.0503 20 20.2051V3.79487C20 2.9497 19.0592 2.46725 18.4 2.97436L16.6 4.35897C16.2444 4.63248 15.7556 4.63248 15.4 4.35897L12.6 2.20513C12.2444 1.93162 11.7556 1.93162 11.4 2.20513L8.6 4.35897C8.24444 4.63248 7.75556 4.63248 7.4 4.35897L5.6 2.97436C4.94076 2.46725 4 2.9497 4 3.79487V20.2051C4 21.0503 4.94076 21.5327 5.6 21.0256L7.4 19.641C7.75556 19.3675 8.24444 19.3675 8.6 19.641ZM6.25 9.94872C6.25 9.52388 6.58579 9.17949 7 9.17949H17C17.4142 9.17949 17.75 9.52388 17.75 9.94872C17.75 10.3736 17.4142 10.7179 17 10.7179H7C6.58579 10.7179 6.25 10.3736 6.25 9.94872ZM7 13.2821H17C17.4142 13.2821 17.75 13.6264 17.75 14.0513C17.75 14.4761 17.4142 14.8205 17 14.8205H7C6.58579 14.8205 6.25 14.4761 6.25 14.0513C6.25 13.6264 6.58579 13.2821 7 13.2821Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketAlt1);
export default __webpack_public_path__ + "static/media/ticket-alt-1.74d63b9e478fdb7897e99f74a7301fbd.svg";
export { ForwardRef as ReactComponent };